import { PUBLIC_SUPPORT_EMAIL } from '../../../shared/config/constants.js'
import { footerTemplate } from '../../components/layoutTemplates.js'
import { privacyPolicyContentTemplate } from '../../components/legalContentTemplates.js'

export type PublicInfoPageKind = 'privacy' | 'support'

/** Renders a public store-compliance page without requiring authentication. */
export function publicInfoPageTemplate(kind: PublicInfoPageKind): string {
	const isPrivacy = kind === 'privacy'
	return `
        <div id="public-info-page">
            <header>
                <img class="login-logo" src="/assets/svg/claim.svg" alt="Tunetoss" />
            </header>
            <main class="public-info-content">
                <h1>${isPrivacy ? 'Privacy Policy' : 'Support'}</h1>
                ${isPrivacy ? privacyPolicyContentTemplate() : supportContentTemplate()}
                <a class="btn secondary" href="/" data-public-route>Back to Tunetoss</a>
            </main>
            ${footerTemplate()}
        </div>
    `
}

function supportContentTemplate(): string {
	return `
        <div class="legal-content">
            <p class="f secondary">For support, feedback, privacy requests, or bug reports, email <a href="mailto:${PUBLIC_SUPPORT_EMAIL}">${PUBLIC_SUPPORT_EMAIL}</a>.</p>

            <h3>In-app support</h3>
            <ol class="legal-list">
                <li>Sign in to Tunetoss with Discogs.</li>
                <li>Open Settings.</li>
                <li>Select Contact &amp; Feedback or Report a Bug.</li>
            </ol>

            <h3>Account deletion</h3>
            <p class="f secondary">You can permanently delete your Tunetoss account and its associated app data from Settings → Account → Delete Account. This does not delete your Discogs account.</p>

            <h3>Sign-in problems</h3>
            <p class="f secondary">If sign-in does not complete, close the authorization browser, reopen Tunetoss, and try again. Discogs authentication or service outages may temporarily prevent access.</p>

            <p class="f secondary">Read the <a href="/privacy" data-public-route>Privacy Policy</a> for details about data handling and privacy choices.</p>
        </div>
    `
}
